import { ActionTypes, LoadingTypes, JourneyDirections, GridPages } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';
import JourneyPlanService from '../services/JourneyPlanService';
import { createLoadingDecoratorFor } from '../decorators/Loading';
import TrackingActions from './TrackingActions';
import PointFlow from '../flows/PointFlow';
import DisruptionAlertActions from './DisruptionAlertActions';
import SearchActions from './SearchActions';

const withTripLoadingActions = createLoadingDecoratorFor(LoadingTypes.TRIP);

// Replacement for Bluebird's Promise.delay
const delay = (ms = 0) => new Promise((resolve) => setTimeout(resolve, ms));

let TripActions = {
    preselectCheapest (cheapestSelection) {
        AppDispatcher.dispatch({
            cheapestSelection,
            actionType: ActionTypes.PRESELECT_CHEAPEST
        });
    },

    selectInwardService (service) {
        AppDispatcher.dispatch({
            service,
            actionType: ActionTypes.INWARD_SERVICE_SELECTED
        });
    },

    selectOutwardService (service) {
        AppDispatcher.dispatch({
            service,
            actionType: ActionTypes.OUTWARD_SERVICE_SELECTED
        });
    },

    selectServiceForDirection (direction, service) {
        return direction === JourneyDirections.OUTWARD ? this.selectOutwardService(service) : this.selectInwardService(service);
    },

    selectFareCategory (fareCategory, service, fareClass) {
        AppDispatcher.dispatch({
            fareCategory,
            service,
            fareClass,
            actionType: ActionTypes.FARE_CATEGORY_SELECTED
        });
    },

    selectFare (fare, direction, service, fareCategory, fareClass) {
        AppDispatcher.dispatch({
            fare,
            direction,
            service,
            fareCategory,
            fareClass,
            actionType: ActionTypes.FARE_SELECTED
        });
        return delay(0); // previously Promise.delay(0) (bluebird)
    },

    selectingCheapestFare() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SELECTING_CHEAPEST_FARE
        });
    },

    selectingNonCheapestFare() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SELECTING_NON_CHEAPEST_FARE
        });
    },

    selectFareOnlyFare (fare) {
        AppDispatcher.dispatch({
            fare,
            actionType: ActionTypes.FARE_ONLY_SELECTED
        });
        return delay(0); // previously Promise.delay(0) (bluebird)
    },


    updateTrip (trip) {
        AppDispatcher.dispatch({
            trip,
            actionType: ActionTypes.TRIP_UPDATED
        });
    },

    @withTripLoadingActions
    async loadPlusBusAvailability (trip) {
        let plusBus = await JourneyPlanService.plusBus(trip);
        AppDispatcher.dispatch({
            trip, plusBus,
            actionType: ActionTypes.TRIP_PLUSBUS_AVAILABILITY_LOADED
        });

        return plusBus;
    },

    addTripToBasket ({ trip, router }) {
        if (trip.raw) {
            TrackingActions.jpCheckoutWithSuggestedProducts();
        }

        // Clear Journey Planner's cache to force allowance revalidation
        if (trip && trip.isTransPennineStaffRover()) {
            SearchActions.resetJourneyStore();
        }

        PointFlow.moveToNext(GridPages.SERVICES, { trip }, router);
        DisruptionAlertActions.addTimetableAlert();
    }
};

export default TripActions;
